import { type FC } from "react";
import classNames from "classnames";
import { styled } from "~/common/mui";
import {
  LOGO_MEDIAS,
  LOGO_MEDIAS_BUSINESS,
  LOGO_MEDIAS_GROWTH,
  LOGO_MEDIAS_PLUS,
  LOGO_MEDIAS_PLUS_BUSINESS,
} from "~/utils/url/staticResources";
import { HOMEPAGE } from "~/utils/url/staticUrls";

type Props = JSX.IntrinsicElements["img"] & {
  variant: MediasVariant;
  href?: boolean;
};

export type MediasVariant = "general" | "plus" | "business" | "plus-business" | "growth";

const LOGO_URLS: Dictionary<string> = {
  general: LOGO_MEDIAS,
  plus: LOGO_MEDIAS_PLUS,
  business: LOGO_MEDIAS_BUSINESS,
  "plus-business": LOGO_MEDIAS_PLUS_BUSINESS,
  plusbusiness: LOGO_MEDIAS_PLUS_BUSINESS,
  growth: LOGO_MEDIAS_GROWTH,
};

export const MediasLogo: FC<Props> = ({ variant, className, alt, href, ...props }) => {
  return (
    <>
      {href ? (
        <a href={HOMEPAGE}>
          <MediasLogoImage
            data-test-id={"logo-medias"}
            data-test-variant={variant}
            src={LOGO_URLS[variant]}
            className={classNames(`medias-logo-text medias-logo-text--${variant}`, className)}
            alt={alt ?? ""}
            {...props}
          />
        </a>
      ) : (
        <MediasLogoImage
          data-test-id={"logo-medias"}
          data-test-variant={variant}
          src={LOGO_URLS[variant]}
          className={classNames(`medias-logo-text medias-logo-text--${variant}`, className)}
          alt={alt ?? ""}
          {...props}
        />
      )}
    </>
  );
};

const MediasLogoImage = styled("img")(({ theme }) => ({
  height: theme.spacing(1.5),
  [theme.breakpoints.up("phone")]: {
    height: theme.spacing(2),
  },
  [theme.breakpoints.up("tablet")]: {
    height: theme.spacing(2.75),
  },
  [theme.breakpoints.up("desktop-s")]: {
    height: theme.spacing(2.75),
  },
}));
